import { NgModule } from '@angular/core';

import { MatchValidator }      from './match.validator';
import { NumberValidator }     from './number.validator';
import { PhoneValidator }      from './phone.validator';
import { PostcodeValidator }   from './postcode.validator';
import { TimeValidator }       from './time.validator';
import { UniquenessValidator } from './uniqueness.validator';

@NgModule({
  declarations: [
    MatchValidator,
    NumberValidator,
    PhoneValidator,
    PostcodeValidator,
    TimeValidator,
    UniquenessValidator
  ],
  exports: [
    MatchValidator,
    NumberValidator,
    PhoneValidator,
    PostcodeValidator,
    TimeValidator,
    UniquenessValidator
  ]
})
export class ValidatorsModule {}
